import {createClient} from '@supabase/supabase-js';

// Project details from Supabase
const SUPABASE_URL='https://irvnaksgeixwpohtlegx.supabase.co';
const SUPABASE_ANON_KEY='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlydm5ha3NnZWl4d3BvaHRsZWd4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwNDMzNzIsImV4cCI6MjA2OTYxOTM3Mn0.bK8zGYvrZdIlTYLIOnm2YZgSlTMBBZ18eqeHqUeMDLo';

// Create supabase client
const supabase=createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

// Test connection
supabase.from('brand_health_submissions_h7f92k3a')
  .select('id')
  .limit(1)
  .then(({data, error}) => {
    if (error) {
      console.error('Supabase connection error:', error);
    } else {
      console.log('Supabase: Connected successfully to brand_health_submissions_h7f92k3a table');
    }
  });

export default supabase;

// Helper function to store form submissions
export const storeFormSubmission = async (submissionData) => {
  try {
    console.log('Storing submission data:', submissionData);
    const {data, error} = await supabase
      .from('brand_health_submissions_h7f92k3a')
      .insert([submissionData]);

    if (error) {
      console.error('Error storing submission:', error);
      return {success: false, error};
    }

    console.log('Submission stored successfully:', data);
    return {success: true, data};
  } catch (err) {
    console.error('Exception when storing submission:', err);
    return {success: false, error: err};
  }
};

// Function to delete a submission
export const deleteSubmission = async (id) => {
  try {
    console.log('Deleting submission with ID:', id);
    
    // First try to delete from completed submissions
    const {error: completedError} = await supabase
      .from('brand_health_submissions_h7f92k3a')
      .delete()
      .eq('id', id);
      
    if (completedError) {
      console.error('Error deleting from completed submissions:', completedError);
      
      // If not found in completed submissions, try partial submissions
      const {error: partialError} = await supabase
        .from('user_sessions_h7f92k3a')
        .delete()
        .eq('id', id);
        
      if (partialError) {
        console.error('Error deleting from partial submissions:', partialError);
        return {success: false, error: partialError};
      }
    }
    
    return {success: true};
  } catch (err) {
    console.error('Exception when deleting submission:', err);
    return {success: false, error: err};
  }
};

// Function to retrieve submissions
export const getSubmissions = async () => {
  try {
    // Get completed submissions
    const {data: completedData, error: completedError} = await supabase
      .from('brand_health_submissions_h7f92k3a')
      .select('*')
      .order('created_at', {ascending: false});

    // Get partial sessions
    const {data: partialData, error: partialError} = await supabase
      .from('user_sessions_h7f92k3a')
      .select('*')
      .order('created_at', {ascending: false});

    if (completedError) {
      console.error('Error fetching completed submissions:', completedError);
      return {success: false, error: completedError};
    }

    if (partialError) {
      console.error('Error fetching partial sessions:', partialError);
      return {success: false, error: partialError};
    }

    // Format partial data to match completed data structure
    const formattedPartialData = partialData.map((session, index) => {
      return {
        id: session.id,
        name: session.name || `Visitor #${index + 1}`,
        email: session.email || 'Not provided',
        company: session.company || 'Not provided',
        role: session.role || 'Not provided',
        created_at: session.created_at,
        tier: 'Partial',
        overall_score: 0,
        brand_strategy_score: 0,
        visual_identity_score: 0,
        website_ux_score: 0,
        marketing_score: 0,
        responses: session.responses || {},
        progress: session.progress || 'Started assessment',
        exit_point: session.exit_point || 'Unknown',
        isPartial: true
      };
    });

    // Combine data, ensuring we don't have duplicates
    const combinedData = [...completedData];

    // Add partial submissions that aren't already in completed
    formattedPartialData.forEach(partial => {
      // Check if this partial submission is already in completed data (by email if available)
      const isDuplicate = 
        partial.email !== 'Not provided' && 
        completedData.some(complete => complete.email === partial.email);
      
      if (!isDuplicate) {
        combinedData.push(partial);
      }
    });

    return {success: true, data: combinedData};
  } catch (err) {
    console.error('Exception when fetching submissions:', err);
    return {success: false, error: err};
  }
};

// Function to track user progress
export const trackUserProgress = async (userData) => {
  try {
    const {data, error} = await supabase
      .from('user_sessions_h7f92k3a')
      .upsert([userData], {onConflict: 'email', ignoreDuplicates: false});

    if (error) {
      console.error('Error tracking user progress:', error);
      return {success: false, error};
    }

    return {success: true, data};
  } catch (err) {
    console.error('Exception when tracking user progress:', err);
    return {success: false, error: err};
  }
};